const PREFIX = 'WEBSOCKET';

export const CONNECT_WS = `${PREFIX}/CONNECT`;
export const DISCONNECT_WS = `${PREFIX}/DISCONNECT`;
export const NEW_LISTENER_WS = `${PREFIX}/NEW_LISTENER`;
export const UPDATE_LAST_ACTIVITY = `${PREFIX}/UPDATE_LAST_ACTIVITY`;
